/* Tessuti wishlist — localStorage-based, no account required. Loaded once in <head> with defer. */
(function () {
  var KEY = 'tessuti_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(id) { return read().some(function (i) { return String(i.id) === String(id); }); }

  function toggle(item) {
    var list = read();
    var idx = list.findIndex(function (i) { return String(i.id) === String(item.id); });
    if (idx > -1) { list.splice(idx, 1); } else { list.unshift(item); }
    write(list);
    return idx === -1; // true = now wishlisted
  }

  function updateBadges() {
    var count = read().length;
    document.querySelectorAll('#t-wish-count, .t-wish-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.some(function (i) { return String(i.id) === String(btn.dataset.id); });
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function onClick(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var item = {
      id: btn.dataset.id,
      handle: btn.dataset.handle,
      title: btn.dataset.title,
      image: btn.dataset.image,
      price: btn.dataset.price,
      url: btn.dataset.url
    };
    var nowOn = toggle(item);
    document.querySelectorAll('[data-wishlist-toggle][data-id="' + CSS.escape(String(item.id)) + '"]').forEach(function (b) {
      b.classList.toggle('is-active', nowOn);
      b.setAttribute('aria-pressed', nowOn ? 'true' : 'false');
    });
    updateBadges();
    document.dispatchEvent(new CustomEvent('tessuti:wishlist-change'));
  }

  document.addEventListener('click', onClick);
  document.addEventListener('DOMContentLoaded', function () { syncButtons(); updateBadges(); });
  if (document.readyState !== 'loading') { syncButtons(); updateBadges(); }

  window.TessutiWishlist = { read: read, has: has, updateBadges: updateBadges, syncButtons: syncButtons };
})();
